module.exports = __webpack_public_path__ + "img/LyP-1.3ef87727.png";